import { render, staticRenderFns } from "./offsideItem.vue?vue&type=template&id=7d135d67&"
import script from "./offsideItem.vue?vue&type=script&lang=js&"
export * from "./offsideItem.vue?vue&type=script&lang=js&"
import style0 from "./offsideItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports